module.exports = __webpack_public_path__ + "static/img/chang_1.0af51e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chang_1.png
// module id = h9el
// module chunks = 0